declare var window: any;
export const isYach = /Yach/i.test(navigator.userAgent);
import Vue from "vue";
import { Message, MessageBox } from "element-ui";
import {
  OSnow,
  ddCompare,
  macddCompare,
  macddCompareNew,
  ddCompareNew
} from "@/utils/func";
import { PATH_MAC_DOWNLOAD, PATH_WIN_DOWNLOAD } from "@/constants/URL";
import "@assets/css/weeklyCss/weeklyUpdate.scss";
import { locale } from "@/locale";
export const isdd = window.dd && window.dd.pc;

//previewImage调用此api，将进行预览图片支持Android,ios,pc(2.7.0)
export const previewImage = (
  urls: [],
  url: string = "",
  callback = data => {}
) => {
  window.dd.ready(() => {
    window.dd.biz.util.previewImage({
      urls: urls, //图片地址列表
      current: url, //当前显示的图片链接
      onSuccess: function(result) {
        /**/
      },
      onFail: function(err) {}
    });
  });
};
// 会话id  永久
export const chooseConversationByCorpId = (
  callBack,
  useraddExtraOptions = {}
) => {
  let corpId = JSON.parse(window.localStorage.getItem("okr_ddConfig")).value
    .corpId;
  // console.log("yach", isYach);
  if (isYach) {
    // console.log("走isyach");
    corpId = localStorage.getItem("corpId");
  }
  // console.log("corpId1", corpId);
  window.dd.ready(() => {
    window.dd.biz.chat.chooseConversationByCorpId({
      corpId: corpId, //企业id,必须是用户所属的企业的corpid
      isAllowCreateGroup: false,
      filterNotOwnerGroup: false,
      multiple: true, // 是否支持多选，默认false
      limitTips: locale("choose_up_to_10"), //超过限定会话提示
      maxConversations: 10, //最大选择会话数量
      ...useraddExtraOptions,
      onSuccess: function(res) {
        // console.log(res, "res2");
        if (res.body) {
          callBack(res.body);
        } else {
          callBack(res);
        }

        //onSuccess将在选择结束之后调用
        // 该cid和服务端开发文档-普通会话消息接口配合使用，而且只能使用一次，之后将失效
        /*{
                                    cid: 'xxxx',
                                    title:'xxx'
                                }*/
      },
      onFail: function(e) {
        // console.log(e, "error");
        //console.log("onFail=>", e);
        //钉钉bug errorcode 不管是关闭还是选非内部群 都是返回9
        if (e.errorMessage != "参数错误") {
          // showToast("请选择带有内部群标识的群组", "error");
        }
      }
    });
  });
};

// 会话  一次
export const pickConversation = callBack => {
  let corpId = JSON.parse(window.localStorage.getItem("okr_ddConfig")).value
    .corpId;
  if (isYach) {
    // console.log("走isyach");
    corpId = localStorage.getItem("corpId");
    // console.log("corpIdaaa", corpId);
  }
  window.dd.ready(() => {
    window.dd.biz.chat.pickConversation({
      corpId, //企业id,必须是用户所属的企业的corpid
      isConfirm: false, //是否弹出确认窗口，默认为true
      onSuccess: function(res) {
        if (res.body) {
          callBack(res.body);
        } else {
          callBack(res);
        }

        //onSuccess将在选择结束之后调用
        // 该cid和服务端开发文档-普通会话消息接口配合使用，而且只能使用一次，之后将失效
        /*{
                                    cid: 'xxxx',
                                    title:'xxx'
                                }*/
      },
      onFail: function() {}
    });
  });
};

// 检验钉钉版本
export const checkVersion = () => {
  try {
    if (window.dd.version && window.dd.version.substr(0, 3) <= "4.5") {
      showToast(
        "检测到您本地钉钉版本过低，为了不影响周报正常展示请升级钉钉版本后再使用周报",
        "error"
      );
    }
  } catch (e) {
    return;
  }
};

// 检验钉钉版本
export const checkVersionOfCardURL = origin => {
  try {
    if (OSnow() == "win32" || OSnow() == "win64") {
      //win
      if (!ddCompare(window.dd.version)) {
        //if (true) {
        localStorage.removeItem("weekCardUpdate");
        if (!localStorage.getItem("weekCardUpdate")) {
          if (origin == 3) {
            MessageBox.alert(
              '<div class="card-week"><p style="color: #47444a;font-weight: 600;">为了提高用户体验，本周我们和钉钉紧急开发，优化了以下内容，快来更新体验一下吧！</p>' +
                "<p style='margin-left: 10px;margin-top: 7px;'>1.支持PC端直接查看周报详情</p>" +
                "<p style='margin-left: 10px;'>2.将转发至群中的链接优化为卡片样式</p>" +
                "<p style='margin-left: 10px;margin-bottom: 7px;'>3.支持复制粘贴图片</p>" +
                "<p>      </p>" +
                "<i>注:请务必更新PC端钉钉，否则无法使用PC端填写周报</i><div>",
              "周报更新啦",
              {
                dangerouslyUseHTMLString: true,
                confirmButtonText: "立即更新",
                showCancelButton: false,
                showClose: false,
                cancelButtonText: "取消",
                beforeClose: () => {
                  // if (OSnow() == "win32" || OSnow() == "win64") {
                  //   window.open(PATH_WIN_DOWNLOAD, "_blank");
                  // } else {
                  //   window.open(PATH_MAC_DOWNLOAD, "_blank");
                  // }
                  equipmentEditionHandle();
                  return false;
                },
                type: "warning"
              }
            )
              .then(() => {
                // localStorage.setItem("weekCardUpdate", "close");
              })
              .catch(() => {
                localStorage.setItem("weekCardUpdate", "close");
              });
          }
        }
      }
      if (ddCompare(window.dd.version) && !ddCompareNew(window.dd.version)) {
        //非强制更新
        /* if (origin == 3 && !localStorage.getItem("weekCardUpdateNew")) {
          MessageBox.confirm(
            '<div class="card-week"><p style="color: #47444a;font-weight: 600;">\n' +
              "为了更好的用户体验，我们更新了接收群的交互</p>" +
              '<p style="color: #47444a;font-weight: 600;">快来更新体验吧～</p>' +
              "<i></i><div>",
            "周报更新啦",
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: "立即更新",
              cancelButtonText: "稍后再说",
              customClass: "chooseupdateConfirmClass",
              /!* showClose: true,*!/
              center: true,
              /!* beforeClose: () => {
                                             if (OSnow() == "win32" || OSnow() == "win64") {
                                               window.open(PATH_WIN_DOWNLOAD, "_blank");
                                             } else {
                                               window.open(PATH_MAC_DOWNLOAD, "_blank");
                                             }
                                             return false;
                                           },*!/
              type: "warning"
            }
          )
            .then(() => {
              localStorage.setItem("weekCardUpdateNew", "close");
              if (OSnow() == "win32" || OSnow() == "win64") {
                window.open(PATH_WIN_DOWNLOAD, "_blank");
              } else {
                window.open(PATH_MAC_DOWNLOAD, "_blank");
              }
            })
            .catch(() => {
              localStorage.setItem("weekCardUpdateNew", "close");
            });
        }*/
        //强制更新
        if (origin == 3 && !localStorage.getItem("weekCardUpdateNew2")) {
          MessageBox.confirm(
            '<div class="card-week"><p style="color: #47444a;font-weight: 600;">\n' +
              "为了提供更好的用户体验，我们优化了周报的交互</p>" +
              '<p style="color: #47444a;font-weight: 600;">快来体验吧！</p>' +
              "<i></i><div>",
            "周报更新啦",
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: "立即更新",
              /* cancelButtonText: "稍后再说",*/
              showCancelButton: false,
              customClass: "updateConfirmClass",
              showClose: false,
              center: true,
              beforeClose: () => {
                // if (OSnow() == "win32" || OSnow() == "win64") {
                //   window.open(PATH_WIN_DOWNLOAD, "_blank");
                // } else {
                //   window.open(PATH_MAC_DOWNLOAD, "_blank");
                // }
                equipmentEditionHandle();
                return false;
              },
              type: "warning"
            }
          )
            .then(() => {
              //localStorage.setItem("weekCardUpdateNew", "close");
              // if (OSnow() == "win32" || OSnow() == "win64") {
              //   window.open(PATH_WIN_DOWNLOAD, "_blank");
              // } else {
              //   window.open(PATH_MAC_DOWNLOAD, "_blank");
              // }
              equipmentEditionHandle();
            })
            .catch(() => {
              // localStorage.setItem("weekCardUpdateNew", "close");
            });
        }
      }
    } else {
      //mac
      if (!macddCompare(window.dd.version)) {
        //if (true) {
        //if (true) {
        localStorage.removeItem("weekCardUpdate");
        if (!localStorage.getItem("weekCardUpdate")) {
          if (origin == 3) {
            MessageBox.alert(
              '<div class="card-week"><p style="color: #47444a;font-weight: 600;">为了提高用户体验，本周我们和钉钉紧急开发，优化了以下内容，快来更新体验一下吧！</p>' +
                "<p style='margin-left: 10px;margin-top: 7px;'>1.支持PC端直接查看周报详情</p>" +
                "<p style='margin-left: 10px;'>2.将转发至群中的链接优化为卡片样式</p>" +
                "<p style='margin-left: 10px;margin-bottom: 7px;'>3.支持复制粘贴图片</p>" +
                "<p>      </p>" +
                "<i>注:请务必更新PC端钉钉，否则无法使用PC端填写周报</i><div>",
              "周报更新啦",
              {
                dangerouslyUseHTMLString: true,
                confirmButtonText: "立即更新",
                cancelButtonText: "取消",
                showClose: false,
                beforeClose: () => {
                  // if (OSnow() == "win32" || OSnow() == "win64") {
                  //   window.open(PATH_WIN_DOWNLOAD, "_blank");
                  // } else {
                  //   window.open(PATH_MAC_DOWNLOAD, "_blank");
                  // }
                  equipmentEditionHandle();
                  return false;
                },
                type: "warning"
              }
            )
              .then(() => {
                //localStorage.setItem("weekCardUpdate", "close");
              })
              .catch(() => {
                localStorage.setItem("weekCardUpdate", "close");
              });
          }
        }
      }
      if (
        macddCompare(window.dd.version) &&
        !macddCompareNew(window.dd.version)
      ) {
        //if(true){
        /*非强制更新*/
        /*if (origin == 3 && !localStorage.getItem("weekCardUpdateNew")) {
          MessageBox.confirm(
            '<div class="card-week"><p style="color: #47444a;font-weight: 600;">\n' +
              "为了更好的用户体验，我们更新了接收群的交互</p>" +
              '<p style="color: #47444a;font-weight: 600;">快来更新体验吧～</p>' +
              "<i></i><div>",
            "周报更新啦",
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: "立即更新",
              cancelButtonText: "稍后再说",
              customClass: "updateConfirmClass",
              /!* showClose: true,*!/
              center: true,
              /!* beforeClose: () => {
                                                 if (OSnow() == "win32" || OSnow() == "win64") {
                                                   window.open(PATH_WIN_DOWNLOAD, "_blank");
                                                 } else {
                                                   window.open(PATH_MAC_DOWNLOAD, "_blank");
                                                 }
                                                 return false;
                                               },*!/
              type: "warning"
            }
          )
            .then(() => {
              localStorage.setItem("weekCardUpdateNew", "close");
              if (OSnow() == "win32" || OSnow() == "win64") {
                window.open(PATH_WIN_DOWNLOAD, "_blank");
              } else {
                window.open(PATH_MAC_DOWNLOAD, "_blank");
              }
            })
            .catch(() => {
              localStorage.setItem("weekCardUpdateNew", "close");
            });
        }*/
        //强制更新
        if (origin == 3 && !localStorage.getItem("weekCardUpdateNew2")) {
          MessageBox.confirm(
            '<div class="card-week"><p style="color: #47444a;font-weight: 600;">\n' +
              "为了提供更好的用户体验，我们优化了周报的交互</p>" +
              '<p style="color: #47444a;font-weight: 600;">快来体验吧！</p>' +
              "<i></i><div>",
            "周报更新啦",
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: "立即更新",
              /* cancelButtonText: "稍后再说",*/
              showCancelButton: false,
              customClass: "updateConfirmClass",
              showClose: false,
              center: true,
              beforeClose: () => {
                // if (OSnow() == "win32" || OSnow() == "win64") {
                //   window.open(PATH_WIN_DOWNLOAD, "_blank");
                // } else {
                //   window.open(PATH_MAC_DOWNLOAD, "_blank");
                // }
                equipmentEditionHandle();
                return false;
              },
              type: "warning"
            }
          )
            .then(() => {
              // localStorage.setItem("weekCardUpdateNew", "close");
              // if (OSnow() == "win32" || OSnow() == "win64") {
              //   window.open(PATH_WIN_DOWNLOAD, "_blank");
              // } else {
              //   window.open(PATH_MAC_DOWNLOAD, "_blank");
              // }
              equipmentEditionHandle();
            })
            .catch(() => {
              // localStorage.setItem("weekCardUpdateNew", "close");
            });
        }
      }
    }
  } catch (e) {
    //console.log("e", e);
  }
};

// 获取微应用免登授权码
export const getPermission = (corpId: string, cb: Function) => {
  window.dd.ready(function() {
    window.dd.runtime.permission.requestAuthCode({
      corpId, // 企业id
      onSuccess: function(info) {
        cb(info.code); // 通过该免登授权码可以获取用户身份
      }
    });
  });
};
//设备识别更新判断
export const equipmentEditionHandle = () => {
  if (OSnow() == "win32" || OSnow() == "win64") {
    window.open(PATH_WIN_DOWNLOAD, "_blank");
  } else {
    window.open(PATH_MAC_DOWNLOAD, "_blank");
  }
};
// toast封装
export const showToast = (
  text: string,
  icon: string = "",
  callback = () => {}
) => {
  // 全局提示  message element dd
  if (window.dd.pc) {
    window.dd.ready(() => {
      window.dd.device.notification.toast({
        icon, //icon样式，有success和error，默认为空 0.0.2
        text,
        duration: 2,
        onSuccess: function() {
          /*{}*/
          callback();
        },
        onFail: function() {}
      });
    });
  } else {
    if (icon == "success" || icon == "error") {
      return Message({
        message: text,
        center: true,
        type: icon
      });
    }
    return Message({
      message: text,
      center: true,
      type: "info"
    });
  }
};

// 选择部门信息接口
export const departmentsPicker = (
  text: string,
  pickedDepartments: Array<any> = [],
  callback = data => {}
) => {
  const ddConfig = Vue.$ls.get("ddConfig");
  let corpId = ddConfig.corpId;
  corpId =
    process.env.NODE_ENV == "development"
      ? "ding4a3d2998af65cdc635c2f4657eb6378f"
      : corpId;
  let appId = ddConfig.appid;
  if (isYach) {
    // console.log("走isyach");
    corpId = localStorage.getItem("corpId");
    appId = localStorage.getItem("appId");
    // console.log("app corp", appId, corpId);
  }
  window.dd.ready(() => {
    window.dd.biz.contact.departmentsPicker({
      title: text, //标题
      corpId, //企业的corpId
      multiple: true, //是否多选
      limitTips: locale("exceeded_limit"), //超过限定人数返回提示
      maxDepartments: 100, //最大选择部门数量
      pickedDepartments, //已选部门
      disabledDepartments: [], //不可选部门
      requiredDepartments: [], //必选部门（不可取消选中状态）
      appId, //微应用的Id
      permissionType: "GLOBAL", //选人权限，目前只有GLOBAL这个参数
      onSuccess: function(result) {
        // console.log(result);
        callback(result);
        /**
                 {
                     userCount:1,                              //选择人数
                     departmentsCount:1，//选择的部门数量
                     departments:[{"id":,"name":"","number":}]//返回已选部门列表，列表中每个对象包含id（部门id）、name（部门名称）、number（部门人数）
                 }
                 */
      },
      onFail: function(err) {
        // console.log(err);
      }
    });
  });
};

// 选人选部门
export const complexPicker = (
  title: string = "测试标题",
  callback = data => {}
) => {
  const ddConfig = Vue.$ls.get("ddConfig");
  let corpId = ddConfig.corpId;
  corpId =
    process.env.NODE_ENV == "development"
      ? "ding4a3d2998af65cdc635c2f4657eb6378f"
      : corpId;
  let appId = ddConfig.appid;
  if (isYach) {
    // console.log("走isyach");
    corpId = localStorage.getItem("corpId");
    appId = localStorage.getItem("appId");
    // console.log("app corp2", appId, corpId);
  }
  // let corpId = "ding4a3d2998af65cdc635c2f4657eb6378f";
  if (isYach) {
    window.dd.biz.contact.complexPicker({
      title, //标题
      corpId,
      multiple: true, //是否多选
      limitTips: locale("up_to_people").replace("[xxx]", 200), //超过限定人数返回提示
      maxUsers: 200, //最大可选人数
      pickedUsers: [], //已选用户
      pickedDepartments: [], //已选部门
      disabledUsers: [], //不可选用户
      disabledDepartments: [], //不可选部门
      requiredUsers: [], //必选用户（不可取消选中状态）
      requiredDepartments: [], //必选部门（不可取消选中状态）
      appId, //微应用的Id
      permissionType: "GLOBAL", //可添加权限校验，选人权限，目前只有GLOBAL这个参数
      responseUserOnly: true, //返回人，或者返回人和部门
      startWithDepartmentId: 0, //仅支持0和-1
      onSuccess: function(result) {
        callback(result.users);

        /**
               {
                   selectedCount:1,                              //选择人数
                   users:[{"name":"","avatar":"","emplId":""}]，//返回选人的列表，列表中的对象包含name（用户名），avatar（用户头像），emplId（用户工号）三个字段
                   departments:[{"id":,"name":"","number":}]//返回已选部门列表，列表中每个对象包含id（部门id）、name（部门名称）、number（部门人数）
               }
               */
      },
      onFail: function(err) {
        // console.log(err);
      }
    });
  } else {
    window.dd.biz.contact.complexPicker({
      title, //标题
      corpId,
      multiple: true, //是否多选
      limitTips: locale("up_items").replace("[xxx]", 10), //超过限定人数返回提示
      maxUsers: 100, //最大可选人数
      pickedUsers: [], //已选用户
      pickedDepartments: [], //已选部门
      disabledUsers: [], //不可选用户
      disabledDepartments: [], //不可选部门
      requiredUsers: [], //必选用户（不可取消选中状态）
      requiredDepartments: [], //必选部门（不可取消选中状态）
      appId, //微应用的Id
      permissionType: "GLOBAL", //可添加权限校验，选人权限，目前只有GLOBAL这个参数
      responseUserOnly: false, //返回人，或者返回人和部门
      startWithDepartmentId: 0, //仅支持0和-1
      onSuccess: function(result) {
        // console.log(result);
        callback(result.users);

        /**
               {
                   selectedCount:1,                              //选择人数
                   users:[{"name":"","avatar":"","emplId":""}]，//返回选人的列表，列表中的对象包含name（用户名），avatar（用户头像），emplId（用户工号）三个字段
                   departments:[{"id":,"name":"","number":}]//返回已选部门列表，列表中每个对象包含id（部门id）、name（部门名称）、number（部门人数）
               }
               */
      },
      onFail: function(err) {
        // console.log(err);
      }
    });
  }
};

// 单选企业联系人
export const choose = (callback = data => {}) => {
  const ddConfig = Vue.$ls.get("ddConfig");
  let corpId = ddConfig.corpId;
  corpId =
    process.env.NODE_ENV == "development"
      ? "ding4a3d2998af65cdc635c2f4657eb6378f"
      : corpId;
  if (isYach) {
    // console.log("走isyach");
    corpId = localStorage.getItem("corpId");
  }
  // let corpId = "ding4a3d2998af65cdc635c2f4657eb6378f";
  window.dd.ready(() => {
    window.dd.biz.contact.choose({
      multiple: false, //是否多选：true多选 false单选； 默认true
      corpId, //企业的corpId
      // max: 10, //人数限制，当multiple为true才生效，可选范围1-1500
      onSuccess: function(data) {
        callback(data);
        /* data结构
                        [{
                          "name": "张三", //姓名
                          "avatar": "
                          http://g.alicdn.com/avatar/zhangsan.png
                          "//头像图片url，可能为空
                          "emplId": '0573', //员工userid
                         },
                         ...
                        ]
                      */
      },
      onFail: function(err) {
        // console.log(err, "eeeee");
      }
    });
  });
};

// 多选企业联系人
export const multipleChoice = (callback = data => {}) => {
  let corpId = JSON.parse(window.localStorage.getItem("okr_ddConfig")).value
    .corpId;
  const ddConfig = Vue.$ls.get("ddConfig");
  let appId = ddConfig.appid;
  // process.env.NODE_ENV == "development"
  //   ? "ding4a3d2998af65cdc635c2f4657eb6378f"
  //   : corpId;
  if (isYach) {
    // console.log("走isyach");
    corpId = localStorage.getItem("corpId");
    appId = localStorage.getItem("appId");

    window.dd.biz.contact.complexPicker({
      title: locale("select"), //标题
      corpId: corpId,
      multiple: true, //是否多选
      limitTips: locale("choose_up_to_10"), //超过限定人数返回提示
      maxUsers: 10, //最大可选人数
      pickedUsers: [], //已选用户
      pickedDepartments: [], //已选部门
      disabledUsers: [], //不可选用户
      disabledDepartments: [], //不可选部门
      requiredUsers: [], //必选用户（不可取消选中状态）
      requiredDepartments: [], //必选部门（不可取消选中状态）
      appId, //微应用的Id
      permissionType: "GLOBAL", //可添加权限校验，选人权限，目前只有GLOBAL这个参数
      responseUserOnly: false, //返回人，或者返回人和部门
      startWithDepartmentId: 0, //仅支持0和-1
      onSuccess: function(result) {
        // console.log("邀请", result);
        callback(result.users);

        /**
               {
                   selectedCount:1,                              //选择人数
                   users:[{"name":"","avatar":"","emplId":""}]，//返回选人的列表，列表中的对象包含name（用户名），avatar（用户头像），emplId（用户工号）三个字段
                   departments:[{"id":,"name":"","number":}]//返回已选部门列表，列表中每个对象包含id（部门id）、name（部门名称）、number（部门人数）
               }
               */
      },
      onFail: function(err) {
        // console.log(err);
      }
    });
  } else {
    window.dd.ready(() => {
      window.dd.biz.contact.choose({
        multiple: true, //是否多选：true多选 false单选； 默认true
        corpId, //企业的corpId
        max: 20, //人数限制，当multiple为true才生效，可选范围1-1500
        onSuccess: function(data) {
          callback(data);
        },
        onFail: function(err) {}
      });
    });
  }
};

export const openUser = (id: string = "", callback = data => {}) => {
  const ddConfig = Vue.$ls.get("ddConfig");
  let corpId = ddConfig.corpId;
  corpId =
    process.env.NODE_ENV == "development"
      ? "ding4a3d2998af65cdc635c2f4657eb6378f"
      : corpId;
  if (isYach) {
    // console.log("走isyach");
    corpId = localStorage.getItem("corpId");
  }
  // let corpId = "ding4a3d2998af65cdc635c2f4657eb6378f";
  window.dd.ready(() => {
    window.dd.biz.util.open({
      name: "profile", //页面名称
      params: {
        id,
        corpId
      }, //传参
      onSuccess: function(result) {
        // console.log("result", result);
        /**/
      },
      onFail: function(err) {
        // console.log("err111", err);
      }
    });
  });
};

// 会话 pc 不支持
/*export const pickConversation = (callback = data => {}) => {
  let ddConfig = Vue.$ls.get("ddConfig");
  let corpId = ddConfig.corpId;
  corpId =
    process.env.NODE_ENV == "development"
      ? "ding4a3d2998af65cdc635c2f4657eb6378f"
      : corpId;
  // let corpId = "ding4a3d2998af65cdc635c2f4657eb6378f";
  window.dd.ready(() => {
    window.dd.biz.chat.pickConversation({
      corpId,
      isConfirm: "false", //是否弹出确认窗口，默认为true
      onSuccess: function(result) {
        callback(result);
        //onSuccess将在选择结束之后调用
        // 该cid和服务端开发文档-普通会话消息接口配合使用，而且只能使用一次，之后将失效
        /!*{
              cid: 'xxxx',
              title:'xxx'
          }*!/
      },
      onFail: function() {}
    });
  });
};*/

// 分享

export const share = (
  url: string = "",
  title: string = "",
  content: string = "",
  image: string = process.env.VUE_APP_API_URL + "/okr-null-logo.png"
) => {
  if (window.dd.version < "4.6.39") {
    showToast("请升级您的钉钉");
    return;
  }
  window.dd.biz.util.share({
    type: 1, //分享类型，0:全部组件 默认；1:只能分享到钉钉；2:不能分享，只有刷新按钮
    url,
    title,
    content,
    image,
    onSuccess: function() {
      //onSuccess将在调起分享组件成功之后回调
      /**/
      showToast(locale("shared_successfully"), "success");
    },
    onFail: function(err) {}
  });
};

// 分享

export const downloadFile = (
  url: string = "",
  name: string = "",
  callback: Function = data => {}
) => {
  window.dd.biz.util.downloadFile({
    url: encodeURI(url), //要下载的文件的url
    name, //定义下载文件名字
    onProgress: function(msg) {
      callback(msg);
      // 文件下载进度回调
    },
    onSuccess: function(result) {
      /*
        true
      */
    },
    onFail: function() {}
  });
};
export const setLeftNavAction = (text = "", cb: Function, control = true) => {
  window.yy.ready(() => {
    window.yy.biz.navigation.setLeft({
      control, //是否控制点击事件，true 控制，false 不控制， 默认false
      text, //控制显示文本，空字符串表示显示默认文本
      onSuccess: () => {
        cb();
      },
      onFail: function() {}
    });
  });
};

export const closeApp = () => {
  window.yy.ready(() => {
    window.yy.biz.navigation.close({
      onSuccess: function(_: any) {},
      onFail: function(_: any) {}
    });
  });
};
export const disableiOSWebView = () => {
  window.yy.ready(() => {
    window.yy.ui.webViewBounce.disable();
  });
};
